<template>
  <v-card v-if="loading" class="control-card preload-box h-100 pa-2" style="min-height: 380px;">
    <v-progress-circular indeterminate color="primary" class="h-100"></v-progress-circular>
  </v-card>
  <div v-else class="control-block">
    <v-layout d-flex wrap style="gap: 16px;">
      <v-layout wrap style="gap: 16px;">
        <v-layout wrap column style="gap: 16px; flex: 1;">
          <v-card class="control-card" style="background-color: rgb(76, 175, 80, 0.2); border-color: #4CAF50;">
            <p class="control-card__title">Пользователей в сети</p>
            <div class="control-card__part">
              <span>За последние полчаса</span>
              <div class="control-card__part--number green--text">{{ controlsData.users.online_users || '-' }}</div>
            </div>
          </v-card>
          <v-card class="control-card">
            <p class="control-card__title">Входов в АС Кобра</p>
            <div class="control-card__part">
              <span>За текущие сутки</span>
              <div class="control-card__part--number blue-grey--text">{{ controlsData.users.logins || '-' }}</div>
            </div>
          </v-card>
        </v-layout>
        <v-card class="control-card" style="gap: 16px;flex: 1;">
          <div class="control-card__part">
            <p class="control-card__title">МРМ</p>
            <span>За текущие сутки</span>
          </div>
          <v-layout d-flex column style="gap: 8px; max-height: 180px; overflow: auto;">
            <div v-for="item in roles" :key="item.name" class="control-card--small">
              <p>{{ item.name }}</p>
              <span :class="{ 'blue--text': item.value === maxRole }">{{ item.value }}</span>
            </div>
          </v-layout>
        </v-card>
      </v-layout>
      <v-card class="control-card" style="width: 100%; min-height: 170px;">
        <p class="control-card__title">Вовлеченность служб</p>
        <div>Количество запусков модулей службами АП за текущие сутки</div>
        <v-chart class="pa-2 chart" :option="chartOptions" autoresize />
      </v-card>
    </v-layout>
    <v-card class="control-card control-card__scroll">
      <p class="control-card__title">Запуск модулей</p>
      <span>За текущие сутки</span>
      <v-layout mt-3 pr-2 column style="gap: 8px; max-height: 100%; overflow: auto;">
        <template v-for="mod in modules">
          <v-layout row align-center style="line-height: 1; flex: 0 1 auto;">
            <div class="d-flex align-center justify-center lighten-4 font-weight-bold"
              :class="[maxModuleValue === mod.value ? 'blue blue--text' : 'grey grey--text']"
              style="width: 32px; min-width: 32px; height: 32px; font-size: 20px; text-align: center; border-radius: 50%;">
              {{ mod.name[0] }}
            </div>
            <div class="mx-2 font-weight-bold" style="flex: 1; width: 100%; overflow: hidden;" :title="mod.name || ''">
              <p class="ma-0 mb-1" style="overflow: hidden; text-overflow: ellipsis;">{{ mod.name }}</p>
              <span class="d-block" :class="[maxModuleValue === mod.value ? 'blue' : 'grey']"
                style="height: 6px; border-radius: 5px;" :style="{ width: getWidth(mod.value) }"></span>
            </div>
            <div class="font-weight-bold blue--text" style="font-size: 20px;">{{ mod.value }}</div>
          </v-layout>
        </template>
      </v-layout>
    </v-card>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import store from '@/store'

const props = defineProps(['loading'])

const controlsData = computed(() => store.getters['controls/getControls'])

const modules = computed(() => {
  if (!controlsData.value.modules) {
    return []
  }
  return controlsData.value.modules.sort((a, b) => b.value - a.value)
})

const maxModuleValue = computed(() => {
  const values = modules.value.map(i => i.value)
  return Math.max(...values)
})

const roles = computed(() => controlsData.value.roles || [])

const maxRole = computed(() => Math.max(...roles.value.map(i => i.value)))

const chartOptions = computed(() => {
  const categories = controlsData.value.users_groups || [];

  const values = categories.map(item => item.value);
  const maxValue = Math.max(...values);

  return {
    tooltip: {
      trigger: 'axis',
      formatter: params => {
        const data = params[0].data;
        return `${params[0].name}<br/>Количество: ${data.value}`;
      }
    },
    xAxis: {
      type: 'category',
      data: categories.map(item => item.name),
      axisLabel: {
        interval: 0,
        rotate: 45
      },
      axisLine: {
        lineStyle: {
          color: '#999'
        }
      }
    },
    yAxis: {
      type: 'value',
      max: maxValue > 0 ? Math.ceil(maxValue / 5) * 5 : 5, // Защита от пустых данных
      axisLine: {
        show: true,
        lineStyle: {
          color: '#999'
        }
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#eee'
        }
      }
    },
    series: [{
      type: 'bar',
      data: values, // Используем массив значений вместо объектов
      itemStyle: {
        color: params => {
          return categories[params.dataIndex].value === maxValue
            ? '#2196F3'
            : '#8AA1AC';
        }
      },
      barWidth: '60%',
      label: {
        show: true,
        position: 'top',
        formatter: params => {
          return categories[params.dataIndex].value;
        }
      }
    }],
    grid: {
      containLabel: true,
      left: '0',
      right: '0',
      bottom: '0',
      top: '10%'
    }
  };
});

const getWidth = (value) => {
  if (maxModuleValue.value === 0) return '100%'
  const percentage = (value / maxModuleValue.value) * 100
  return `${percentage}%`
}
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
  min-height: 170px;
  min-width: 300px;
}
</style>